import NewArrivals from './NewArrivals';

export default NewArrivals;
